import { Box, Typography, useTheme } from "@mui/material";

interface WhyWorkAtHungerfordProps {
  heading?: string;
  subHeading?: string;
  content: string;
  imageSrc: string;
  imageAlt?: string;
  reverse?: boolean;
  maxWidth?: string;
  textWidth?: string;
  alignTextVertical?: "top" | "center";
  mTop?: number;
  imageVariant?: "default" | "tall";
}

const WhyWorkAtHungerford: React.FC<WhyWorkAtHungerfordProps> = ({
  heading,
  subHeading,
  content,
  imageSrc,
  imageAlt = "Team at Hungerford",
  reverse,
  maxWidth = "1050px",
  textWidth = "650px",
  alignTextVertical,
  mTop = 12,
  imageVariant = "default",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mt: { xs: 6, sm: 6, lg: mTop },
        maxWidth: { maxWidth },
        mx: "auto",
        mb: { xs: 2, sm: 4, lg: 10 },
      }}
    >
      {/* Heading */}
      {heading && (
        <Typography
          variant="h3"
          align="left"
          gutterBottom
          sx={{ fontWeight: 700, mb: { xs: 2, md: 4 }, maxWidth: textWidth }}
        >
          {heading}
        </Typography>
      )}

      {/* Content: text + image */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: reverse ? "row-reverse" : "row" },
          alignItems: {
            xs: "stretch",
            lg: alignTextVertical === "top" ? "flex-start" : "flex-center",
          },
          justifyContent: "center",
          gap: { xs: 4, md: 8 },
        }}
      >
        {/* Text */}
        <Box
          flex={1}
          sx={{
            maxWidth: { lg: "750px" },
            mx: { xs: "auto", md: 0 },
            alignItems: "flex-start",
          }}
        >
          {/* SubHeading opcional */}
          {subHeading && (
            <Typography
              variant="h3"
              gutterBottom
              sx={{ fontWeight: 700, mb: { xs: 2, md: 3 }, textAlign: "left" }}
            >
              {subHeading}
            </Typography>
          )}
          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.75,
              textAlign: "justify",
              whiteSpace: "pre-line",
            }}
          >
            {content}
          </Typography>
        </Box>

        {/* Image */}
        <Box
          flex={1}
          sx={{
            mx: { xs: "auto", md: 0 },
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: theme.shadows[2],
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            ...(imageVariant === "tall"
              ? { maxWidth: "300px", maxHeight: "380px" } //  versión imagen vertical
              : { maxHeight: "500px", width: "100%" }), // default
          }}
        >
          <img
            src={imageSrc}
            alt={imageAlt}
            style={{
              width: imageVariant === "tall" ? "100%" : "100%",
              height: "auto",
              objectFit: imageVariant === "tall" ? "contain" : "cover",
              borderRadius: "16px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default WhyWorkAtHungerford;
